<template>
  <div class="header">
    <div class="title-container">
      <h1 class="header-title">
        百川作业订正系统
        <span class="class-tag" v-if="classNameDisplay !== '班级'" :style="{ backgroundColor: subjectColor }" @click="handleClassTagClick">
          {{ classNameDisplay }}
        </span>
      </h1>
    </div>
    <div class="poem">
      百川东到海，何时复西归？<br>
      少壮不努力，老大徒伤悲。
    </div>
    <div class="current-time">{{ currentTime }}</div>
  </div>
</template>

<script>
import Utils from '@/utils/Utils'

export default {
  name: 'HeaderSectionMobile',
  props: {
    classManagementForm: {
      type: Object,
      default: () => ({})
    },
    subjectIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentTime: ''
    }
  },
  computed: {
    classNameDisplay() {
      if (this.classManagementForm) {
        return Utils.formatClassName(this.classManagementForm.grade, this.classManagementForm.classNumber);
      }
      return '班级';
    },
    subjectColor() {
      const colors = ['#E67E22', '#409EFF', '#E91E63'];
      return colors[this.subjectIndex] || '#409EFF';
    }
  },
  mounted() {
    this.updateTime();
    setInterval(this.updateTime, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    updateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      this.currentTime = `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`;
    },
    handleClassTagClick() {
      this.$emit('switch-to-next-class');
    }
  }
}
</script>

<style scoped>
.header {
  background: linear-gradient(90deg, #409EFF, #64b5f6);
  color: white;
  padding: 10px;
  border-radius: 15px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  flex-wrap: wrap;
}

.title-container {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 150px;
  justify-content: center;
}

.header-title {
  font-size: 22px;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
  margin: 0;
  text-align: center;
  position: relative;
}

.class-tag {
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translate(100%, -50%);
  white-space: nowrap;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.class-tag:active {
  transform: translate(100%, -50%) scale(0.95);
}

.poem {
  flex: 1;
  font-size: 16px;
  text-align: center;
  line-height: 1.4;
  font-weight: bold;
  margin: 0 10px;
  min-width: 150px;
}

.current-time {
  flex: 0 0 auto;
  font-size: 20px;
  font-weight: bold;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
  white-space: nowrap;
  min-width: 120px;
}

@media (orientation: portrait) {
  .header {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 15px 10px;
  }
  
  .title-container {
    justify-content: center;
    margin-bottom: 5px;
    width: 100%;
  }
  
  .header-title {
    font-size: 22px;
    margin-bottom: 5px;
  }
  
  .poem {
    font-size: 16px;
    margin: 5px 0;
  }
  
  .current-time {
    font-size: 20px;
    margin-top: 5px;
  }
}

@media (orientation: landscape) {
  .header {
    flex-direction: row;
  }
  
  .header-title {
    font-size: 20px;
  }
  
  .poem {
    font-size: 14px;
  }
  
  .current-time {
    font-size: 18px;
  }
}
</style>
